import request from '@/utils/request'

export function updateUser(companies) {
  var data = companies.data;
  return request({
    url: 'user/update-profile/' + companies.id,
    method: 'post',
    data
  })

}
export function showUser(id) {
  return request({
    url: '/user/profile/' + id,
    method: 'get',
  })
}

/**
 * Get  All TimeZone data
 * @param {*} param0 
 * @param {*} users 
 * @param {*} id 
 */
export function getTimeZone() {
  return request({
    url: '/get-timezones',
    method: 'get',
  })
}

export function checkStartMeeting(id) {
  return request({
    url: '/time-selection/' + id,
    method: 'get',
  })
}
